import qs, { ParsedQs } from 'qs';

export const parseQueryParams = (url: string = window.location.search): ParsedQs =>
  qs.parse(url.split('?')[1], { ignoreQueryPrefix: true });

export const stringifyQueryParams = (paramsObject: unknown) => qs.stringify(paramsObject, { arrayFormat: 'brackets' });
